module.exports = (state, action) => {
  const messageData = action.payload
  state.notificationData = messageData
  state.isShown = true
}
